export default "/fires.60cfa479-c614ab.svg";